// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.photo-uploader-container {
    width: 800px;
    align-items: center;
    justify-content: center;
    margin: auto;
    border-radius: 12px;
    padding: 16px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
    font-family: sans-serif;
}

h2 {
    text-align: left;
    margin-bottom: 20px;
    color: #d9d9d9;
}


.photo-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 12px;
}

.photo-slot {
    position: relative;
    width: 100%;
    aspect-ratio: 3 / 4;
    background: #242424;
    border: 2px dashed #ccc;
    border-radius: 8px;
    overflow: hidden;
}

.photo-slot img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.remove-btn {
    position: absolute;
    top: 4px;
    right: 4px;
    background: #242424;
    border: none;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    font-size: 20px;
    font-weight: bold;
    color: #1cd66a;
    cursor: pointer;
}

.add-btn {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 24px;
    color: #1cd66a;
    cursor: pointer;
}

.save-btn {
    margin-top: 16px;
    width: 100%;
    background: #1cd66a;
    border: none;
    padding: 10px;
    border-radius: 24px;
    color: #000000;
    font-weight: bold;
    font-size: 16px;
    cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/styles/profile_photo_uploader.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,yCAAyC;IACzC,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;AAClB;;;AAGA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,iBAAiB;IACjB,eAAe;IACf,eAAe;AACnB","sourcesContent":[".photo-uploader-container {\n    width: 800px;\n    align-items: center;\n    justify-content: center;\n    margin: auto;\n    border-radius: 12px;\n    padding: 16px;\n    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);\n    font-family: sans-serif;\n}\n\nh2 {\n    text-align: left;\n    margin-bottom: 20px;\n    color: #d9d9d9;\n}\n\n\n.photo-grid {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 12px;\n}\n\n.photo-slot {\n    position: relative;\n    width: 100%;\n    aspect-ratio: 3 / 4;\n    background: #242424;\n    border: 2px dashed #ccc;\n    border-radius: 8px;\n    overflow: hidden;\n}\n\n.photo-slot img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n\n.remove-btn {\n    position: absolute;\n    top: 4px;\n    right: 4px;\n    background: #242424;\n    border: none;\n    border-radius: 50%;\n    width: 40px;\n    height: 40px;\n    font-size: 20px;\n    font-weight: bold;\n    color: #1cd66a;\n    cursor: pointer;\n}\n\n.add-btn {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-size: 24px;\n    color: #1cd66a;\n    cursor: pointer;\n}\n\n.save-btn {\n    margin-top: 16px;\n    width: 100%;\n    background: #1cd66a;\n    border: none;\n    padding: 10px;\n    border-radius: 24px;\n    color: #000000;\n    font-weight: bold;\n    font-size: 16px;\n    cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
